import { Navigate, useLocation } from 'react-router-dom';
import { ORG_PATH_PREFIX, RESERVED_ROOT_SEGMENTS, orgBasePath } from '@/lib/routes';
import { NotFoundPage } from '@/pages/errors/NotFoundPage';

/**
 * Forwards a pre-`/orgs` org URL (`/acme/agents/x`) to the prefixed
 * namespace (`/orgs/acme/agents/x`) in one hop so the query string and
 * hash survive. Mounted as the dynamic catch-all below every static
 * route, so route ranking keeps reserved paths away from it; the
 * reserved check below is defensive (it also catches reserved paths
 * with unrouted suffixes, e.g. `/profile/x/y`, that fall through to the
 * catch-all). Does not validate the slug against memberships — that is
 * `OrgSlugResolver`'s job, including its one-shot `/auth/me` self-heal
 * for slugs the current auth state doesn't know yet.
 */
export function LegacyOrgPathRedirect() {
  const { pathname, search, hash } = useLocation();
  const [first, ...rest] = pathname.split('/').filter(Boolean);
  if (!first || first === ORG_PATH_PREFIX || RESERVED_ROOT_SEGMENTS.has(first)) {
    return <NotFoundPage />;
  }
  const suffix = rest.length > 0 ? `/${rest.join('/')}` : '';
  return <Navigate to={`${orgBasePath(first)}${suffix}${search}${hash}`} replace />;
}
